module.exports = {
      id: "disableedit-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#disableedit",
      toString: function () {
        return this.url;
      }
    }